import { SidebarLayoutNew } from '../components/sidebar-layout-new'
import { BreadcrumbsNew } from '../components/breadcrumbs'
import { Fragment } from 'react/jsx-runtime'
const pages = [
  { name: "Custom Labels", href: "/custom-labels", current: true },
];
export default function CustomLabels() {
  return (
    <Fragment>
      <SidebarLayoutNew selected_menu="custom-labels">
        <BreadcrumbsNew pages={pages} />
       </SidebarLayoutNew>
    </Fragment>
  );
}